import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";

const ButtonLoad = (props) => {
  const { children, ...attribute } = props;
  return (
    <Button color="primary" {...attribute}>
      <FontAwesome fa="arrow-down" /> {children}
    </Button>
  );
};

ButtonLoad.propTypes = {
  children: PropTypes.any,
};

ButtonLoad.defaultProps = {};

export default ButtonLoad;
